(function () {
    'use strict';

    var CONFIG = {
        endpoint: '/apps/trainingportal/api/checkcontract/',
        pollInterval: 500,
        maxAttempts: 120,
        debug: false,
        containerId: 'contract-container',
        testMode: false,
        testUserId: '24366318125435'
    };

    var state = {
        sentKeys: {},
        inFlightKeys: {},
        attempts: 0,
        started: false,
        resolved: false,
        signed: false,
        observer: null,
        waitingForViewed: true,
        lastViewed: null,
        pressButtonAttached: false
    };

    function log() {
        if (!CONFIG.debug) {
            return;
        }
        console.log.apply(console, ['[CourseContractCheck]'].concat([].slice.call(arguments)));
    }

    function isCoursePage() {
        return (
            window.location.pathname === '/apps/my/courses/list'
        );
    }

    function isCoursePage2() {
        return (
            window.location.pathname === '/apps/my/courses/list' &&
            new URLSearchParams(window.location.search).has('course')
        );
    }

    function ensureContainer() {
        var existing = document.getElementById(CONFIG.containerId);

        if (existing) {
            return existing;
        }

        var div = document.createElement('div');
        div.id = CONFIG.containerId;
        div.className = 'contract-container';
        div.innerHTML = 'Loading Your Courses....';

        document.body.appendChild(div);

        return div;
    }

    function getContainer() {
        return document.getElementById(CONFIG.containerId) || ensureContainer();
    }

    function showContainer() {
        var el = getContainer();
        if (el) {
            el.style.display = 'flex';
        }
    }

    function hideContainer() {
        var el = getContainer();
        if (el) {
            el.style.display = 'none';
        }
    }

    function getUserId() {
        if (typeof window.cusid !== 'undefined' && window.cusid) {
            return String(window.cusid);
        }
        return null;
    }

    function getProductId() {
        if (state.pendingProductId) {
            return String(state.pendingProductId);
        }

        var activeCourseEl =
            document.querySelector('[data-prod-id][data-prod-shop]') ||
            document.querySelector('[data-prod-id]');

        if (!activeCourseEl) {
            return null;
        }

        var productId = activeCourseEl.getAttribute('data-prod-id');
        return productId ? String(productId) : null;
    }

    function getShopDomain() {
        if (window.Shopify && window.Shopify.shop) {
            return window.Shopify.shop;
        }

        var el = document.querySelector('[data-prod-shop]');
        if (el) {
            return el.getAttribute('data-prod-shop');
        }

        return window.location.hostname;
    }

    function isTestUser(userId) {
        if (!CONFIG.testMode) {
            return true;
        }

        return String(userId) === String(CONFIG.testUserId);
    }

    function buildKey(userId) {
        return String(userId);
    }

    function stopWatching() {
        if (state.observer) {
            state.observer.disconnect();
            state.observer = null;
        }
    }

    function resetForNewCourse() {
        state.sentKeys = {};
        state.inFlightKeys = {};
        state.attempts = 0;
        state.resolved = false;
        state.signed = false;
        state.waitingForViewed = true;
        state.lastViewed = null;

        log('Reset for new course'
        );
    }

    function markSigned() {
        state.resolved = true;
        state.signed = true;
        hideContainer();

        log('Contract signed, container hidden');
    }

    function markUnsigned(data) {
        state.resolved = true;
        state.signed = false;
        showContainer();

        log('Contract not signed');

        if (data && data.redirect_url) {
            window.location.href = data.redirect_url;
            return;
        }
        
        $('#'+CONFIG.containerId).html(data.html);
        
        //alert('You must sign the course contract before accessing this course.');
    }

    function shouldCheckContract() {
        return true
    }

    function postContractCheck(userId) {
        if (state.resolved) {
            return;
        }

        if (!userId) {
            log('Missing userId', {
                userId: userId
            });
            return;
        }

        if (!isTestUser(userId)) {
            log('Test mode active - skipping non-test user');
            hideContainer();
            return;
        }

        if (!shouldCheckContract()) {
            log('Skipping contract check because viewed is not 0', {
                viewed: state.lastViewed
            });
            hideContainer();
            return;
        }

        var key = buildKey(userId);

        if (state.sentKeys[key] || state.inFlightKeys[key]) {
            log('Already checked or in flight', key);
            return;
        }

        state.inFlightKeys[key] = true;

        log('Posting payload', {
            user_id: userId,
            shop: getShopDomain(),
            url: window.location.href,
            viewed: state.lastViewed
        });

        var formData = new URLSearchParams();
        formData.append('user_id', String(userId));
        formData.append('shop', getShopDomain());
        formData.append('url', window.location.href);
        formData.append('viewed', String(state.lastViewed));

        fetch(CONFIG.endpoint, {
            method: 'POST',
            body: formData
        })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('HTTP ' + response.status);
            }
            return response.json();
        })
        .then(function (data) {
            delete state.inFlightKeys[key];
            state.sentKeys[key] = true;

            log('Endpoint response', data);

            if (data && data.signed === true) {
                markSigned();
                return;
            }

            if (data && data.course === null) {
                markSigned();
                return;
            }

            markUnsigned(data);
        })
        .catch(function (error) {
            delete state.inFlightKeys[key];
            log('Request failed', error);

            hideContainer();
        });
    }

    function tryDetectAndSend() {
        if (state.resolved) {
            return true;
        }

        state.attempts++;

        var userId = getUserId();
        //var productId = getProductId();

        if (!isTestUser(userId)) {
            log('Test mode active - skipping non-test user');
            hideContainer();
            return false;
        }

        log('Attempt', state.attempts, {
            userId: userId,
            viewed: state.lastViewed,
            waitingForViewed: state.waitingForViewed
        });

        if (userId && shouldCheckContract()) {
            postContractCheck(userId);
            return true;
        }

        return false;
    }

    function startPolling() {
        if (state.started) {
            return;
        }

        state.started = true;

        var timer = setInterval(function () {
            if (state.resolved) {
                clearInterval(timer);
                return;
            }

            if (!state.waitingForViewed) {
                tryDetectAndSend();
            }

            if (state.attempts >= CONFIG.maxAttempts) {
                clearInterval(timer);
                log('Stopped polling after max attempts');

                showContainer();
            }
        }, CONFIG.pollInterval);
    }

    function watchDom() {
        state.observer = new MutationObserver(function () {
            if (state.resolved || state.waitingForViewed) {
                return;
            }

            var userId = getUserId();
            //var productId = getProductId();

            if (!isTestUser(userId)) {
                return;
            }

            if (userId && shouldCheckContract()) {
                postContractCheck(userId);
            }
        });

        state.observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }

    function handleGetSeclesResponse(responseText) {
        if (state.resolved) {
            return;
        }

        try {
            var data = JSON.parse(responseText);

            if (!data || !Array.isArray(data.data)) {

                log('membpage response invalid');

                return;

            }

            state.waitingForViewed = false;


            log('getsecles viewed detected', {
                viewed: state.lastViewed
          
            });

            var userId = getUserId();
            //var productId = getProductId();

            if (!isTestUser(userId)) {
                hideContainer();
                log('Test mode active - not target user after getsecles');
                return;
            }

            showContainer();

            if (userId) {

                postContractCheck(userId);

            }
        } catch (error) {
            log('Failed to parse getsecles response', error);
        }
    }

    function interceptFetch() {
        if (!window.fetch) {
            return;
        }

        var originalFetch = window.fetch;

        window.fetch = function () {
            var args = arguments;
            var url = args[0];

            if (CONFIG.debug) { console.log('[CourseContractCheck] INTERCEPT URL:', url); }

            return originalFetch.apply(this, args).then(function (response) {
                try {
                    if (
                        !state.resolved &&
                        typeof url === 'string' &&
                        url.indexOf('/courses/getcourseinfo') !== -1
                    ) {

                        if (CONFIG.debug) { console.log('[CourseContractCheck] COURSE RESPONSE', this.responseText); }

                        response.clone().text().then(function (text) {
                            handleGetSeclesResponse(text);
                        });
                    }
                } catch (error) {
                    log('Fetch intercept error', error);
                }

                return response;
            });
        };
    }

    function interceptXHR() {
        var originalOpen = XMLHttpRequest.prototype.open;

        XMLHttpRequest.prototype.open = function (method, url) {
            this._trackedUrl = url;
            return originalOpen.apply(this, arguments);
        };

        var originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.send = function () {
            this.addEventListener('load', function () {

                if (CONFIG.debug) { console.log('[CourseContractCheck] XHR URL:', this._trackedUrl); }

                if (
                    !state.resolved &&
                    typeof this._trackedUrl === 'string' &&
                    this._trackedUrl.indexOf('/courses/getcourseinfo') !== -1
                ) {
                    handleGetSeclesResponse(this.responseText);
                }
            });

            return originalSend.apply(this, arguments);
        };
    }

    function interceptPressButton() {
        function attachInterceptor() {
            if (typeof window.pressButton !== 'function') {
                return false;
            }

            if (state.pressButtonAttached || window.pressButton.__contractIntercepted) {
                return true;
            }

            var originalPressButton = window.pressButton;

            window.pressButton = function () {
                //var normalizedProductId = productId ? String(productId) : null;
                var userId = getUserId();

                log('pressButton intercepted', {
                    userId: userId
                });

                if (isTestUser(userId)) {
                    ensureContainer();
                    resetForNewCourse();
                    showContainer();
                } else {
                    hideContainer();
                }

                var result = originalPressButton.apply(this, arguments);

                return result;
            };

            window.pressButton.__contractIntercepted = true;
            state.pressButtonAttached = true;

            log('pressButton interceptor attached');

            return true;
        }

        if (attachInterceptor()) {
            return;
        }

        var tries = 0;
        var timer = setInterval(function () {
            tries++;

            if (attachInterceptor() || tries >= 120) {
                clearInterval(timer);
            }
        }, 250);
    }

    function contractCompleted(data)
    {
            hideContainer();
    }

    function init() {

        if (!isCoursePage()) {
            hideContainer();
            return;
        }

        log('Init Course Page');

        var userId = getUserId();

        if (!userId) {
            log('No user ID found');
            return;
        }

        if (!isTestUser(userId)) {
            hideContainer();
            return;
        }

        ensureContainer();
        showContainer();

        postContractCheck(userId);
    }

    function initOld() {
        
        interceptPressButton();
        interceptFetch();
        interceptXHR();

        if (!isCoursePage()) {
            hideContainer();
            return;
        }

        log('Init Course Page');

        if (CONFIG.testMode) {
            log('TEST MODE ACTIVE', {
                testUserId: CONFIG.testUserId
            });
        }

        var userId = getUserId();

        if (userId && !isTestUser(userId)) {
            hideContainer();
            log('Test mode active - not target user, exiting');
            return;
        } else {
            ensureContainer();
        }

        showContainer();
        startPolling();
        watchDom();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();